module.exports = __webpack_public_path__ + "img/login_bg.f49e9a4a.png";